import styled from "styled-components";

export const ListenUploadWrapper = styled("div")`
  position: relative;
  background-color: ${(props) => props.theme.colors.White};
  border-radius: 10px;
  width: 100%;
  box-shadow: 0 0 2px 0 rgba(21, 115, 229, 0.16);
  height: ${(props) => props.height};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease-in-out;
  &:hover {
    background-color: #1573e5;
    svg {
      color: #fff;
    }
    .title {
      color: #fff;
    }
  }
`;

export const ListenPreview = styled("div")`
  position: relative;
  border-radius: 10px;
  background-color: ${(props) => props.theme.colors.White};
  width: 100%;
  box-shadow: 0 0 2px 0 rgba(21, 115, 229, 0.16);
  height: ${(props) => props.height};
`;

export const ListenUploaderTitle = styled("h3")`
  font-size: 24px;
  font-weight: 500;
  color: #697482;
  text-align: center;
`;

export const ListenPreviewPublished = styled("div")`
  box-shadow: 0 0 6px 0 rgba(31, 119, 180, 0.2);
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  font-size: 16px;
  z-index: 3;
`;

export const ListenUploaderDescriptionWrapper = styled("div")`
  border-radius: 10px;
  width: 100%;
  padding: 10px;
  box-shadow: 0 0 2px 0 rgba(21, 115, 229, 0.16);
  background-color: #fff;
`;

export const TrianglePlay = styled("div")`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 25px 0 25px 50px;
  border-color: transparent transparent transparent #007bff;
`;

export const ListenUploadLoaderWrapper = styled("div")`
  position: relative;
  border-radius: 10px;
  width: 100%;
  box-shadow: 0 0 2px 0 rgba(21, 115, 229, 0.16);
  height: ${(props) => props.height};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  flex-direction: column;
  gap: 10px;
`;

export const ButtonInput = styled("label")`
  font-family: Inter, sans-serif;
  cursor: pointer;
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  border: 1px solid rgb(21, 115, 229);
  height: 40px;
  background-color: rgb(21, 115, 229);
  font-size: 16px;
  color: rgb(255, 255, 255);
  border-radius: 15px;
  padding: 0px 17px;
  text-decoration: none;
  letter-spacing: 0.2px;
  font-weight: 500;
  box-shadow: rgba(112, 112, 112, 0.16) 3px 3px 6px 0px;
  text-align: center;
  transition: all 0.2s ease-in-out 0s;
  margin-bottom: 0px;
  outline: none;
`;
